export default " <ng-content></ng-content>\n\n";